import { DisposersStore } from 'stores';

export const couponFormDisposers = new DisposersStore();
